import { ReactNode, useEffect, useLayoutEffect, useRef, useState } from 'react';
import useResizeObserver from 'use-resize-observer';

type GrowHeightContainerProps = {
    children: ReactNode | ReactNode[];
    className?: string;
    dataIntercomTarget?: string;
};
function GrowHeightContainer({ children, className, dataIntercomTarget }: GrowHeightContainerProps): JSX.Element {
    const [marginBottom, setMarginBottom] = useState<number>();
    const ref = useRef<HTMLDivElement>(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const pillList = ref.current.querySelector('[data-filter-pill-list]');
        if (pillList) {
            setMarginBottom(pillList?.scrollHeight);
        } else {
            setMarginBottom(undefined);
        }
    });

    return (
        <div
            ref={ref}
            style={{ marginBottom }}
            className={className}
            {...(dataIntercomTarget ? { 'data-intercom-target': dataIntercomTarget } : {})}
        >
            {children}
        </div>
    );
}

export default GrowHeightContainer;
